import React, {forwardRef, useState, useEffect} from 'react'
import ReactDatePicker, { registerLocale  } from 'react-datepicker'
import SearchableSelect from 'util/component/SearchableSelect'
import { dateToDateFormat } from 'util'
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";

import ko from "date-fns/locale/ko";

registerLocale("ko", ko);

const CustomInput = forwardRef(({value, onClick}, ref) => {
    
    return <div className={"custom-input-inner"} onClick={onClick} ref={ref}>
        {value || "Due Date"}
    </div>
})

const DueDateSelector = (props) => {

    const { dueDate = "", setDate, disabled = true } = props;
    return (
        <div className="custom-input">
            Due Date
            <ReactDatePicker
                disabled={disabled}
                showIcon
                selected={dueDate && setMinutes(new Date(dueDate), 0)}
                onChange={(date) => {setDate(dateToDateFormat(date))}}
                customInput={<CustomInput />}
                showTimeSelect
                minDate={new Date()}
                locale="ko"
                timeFormat="HH:00"
                dateFormat="yyyy/MM/dd HH:mm 'KST'"
                timeIntervals={60}
                placeholderText='Due Date'
            />
            
        </div>
    )
}

const areEquals = (prev, next) => {
    return false;
}

// export default React.memo(DueDateSelector, areEquals);
export default DueDateSelector